
/* ============================== src/utils/taskActions.js ============================== */
// path: frontend/src/utils/taskActions.js
/**
 * Действия над задачей: смена статуса и удаление. Только бизнес-логика —
 * без побочных эффектов.
 *
 * changeTaskStatus({ task, newStatus }) возвращает:
 *   undefined             — задачи нет;
 *   false                 — сервер в task.permissions.allowedStatuses
 *                           не разрешил переход;
 *   { status: newStatus } — патч для PATCH /tasks/:id.
 *
 * allowedStatuses считает сервер (domain/entity-permissions.ts::
 * computeTaskPermissions) по effective-ролям и scope. Окончательная
 * проверка — TaskService.update (403 «Недопустимый переход статуса»).
 *
 * Если в кэше task.permissions отсутствует (edge case: старая задача до
 * миграции), не блокируем на клиенте — fail-open к серверу. PATCH уйдёт,
 * сервер либо применит, либо вернёт 403; так избегаем ложных отказов
 * из-за расхождения кэша.
 *
 * closed_at / archived / archived_at / history вычисляет сервер
 * (TaskService._applyFinalStatusTransition) — фронт не дублирует.
 *
 * deleteTask({ task }) возвращает id для DELETE /tasks/:id (или undefined).
 */

export function changeTaskStatus({ task, newStatus }) {
  if (!task) return;
  const allowed = task.permissions?.allowedStatuses;
  if (Array.isArray(allowed) && !allowed.includes(newStatus)) return false;
  return { status: newStatus };
}

export function deleteTask({ task }) {
  if (!task) return;
  return task.id;
}
